import { createFileRoute, redirect } from '@tanstack/react-router';
import { useMemo } from 'react';

import { featureFlags } from '@/lib/env';
import {
  getSelfReportPatternConfig,
  isSelfReportPatternId,
} from '@/routes/_staff/it-operation-core/_root/in-house-packages/-query/api';

import { SelfReportPatternConfigPage } from './-components/SelfReportPatternConfigPage';

export const Route = createFileRoute(
  '/_staff/it-operation-core/self-report-patterns/$patternId/',
)({
  beforeLoad: ({ params }) => {
    if (!featureFlags.check('ENABLE_IN_HOUSE_OPERATION_PACKAGE')) {
      throw redirect({ to: '/it-operation-core/packages' });
    }
    // セルフレポート以外のパターン ID は汎用パターン設定画面へ委譲する
    if (!isSelfReportPatternId(params.patternId)) {
      throw redirect({
        to: '/it-operation-core/config/$patternId',
        params: { patternId: params.patternId },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { patternId } = Route.useParams();
  const initialConfig = useMemo(
    () => getSelfReportPatternConfig(patternId),
    [patternId],
  );

  if (!initialConfig) return null;

  return <SelfReportPatternConfigPage initialConfig={initialConfig} />;
}
